import React from 'react';
import { Link } from 'react-router-dom';
import Layout from '../components/Layout';
import Seo from '../components/Seo';

const NotFoundPage = () => (
  <Layout>
    <Seo title="الصفحة غير موجودة" />
    <div className="container-responsive py-24 text-center">
      <p className="text-6xl font-bold text-gold-600">404</p>
      <h1 className="mt-4 text-3xl font-bold">الصفحة غير موجودة</h1>
      <p className="mt-3 text-stone-500">قد تكون نُقلت أو لم تُنشأ بعد.</p>
      <div className="mt-8 flex justify-center gap-3">
        <Link to="/" className="btn btn-primary">الرئيسية</Link>
        <Link to="/martyrs" className="btn btn-outline">الشهداء</Link>
      </div>
    </div>
  </Layout>
);

export default NotFoundPage;
